import { History } from 'history';
import * as React from 'react';
import { HotelSearchResultWithUrlReqKeyMainPanel } from 'src/hotels/HotelSearchResultWithUrlReqKeyMainPanel';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { RecieveHotelDetailDataControlManager } from '../hotels/hotel-common-utils';
import { HotelsLeftSide } from '../hotels/HotelsLeftSide'; 
import { HotelBedData } from '../shared/index';
import { getAjaxhelper } from '../utils/index';
import { sendHotelAvailibilityRequest } from '../utils/req-available-helper';
import { LOCAL_STORAGE_KEY_WISHLIST, SESSION_STORAGE_HOTEL_FILTER_CURRENT_REQ_KEY } from 'src/core';
export interface WishlistPanelProps extends BaseComponentProps {
    id: string;
    lang: string;
    currency: string;
    pageSize: number;
    history: History;
    wishlistCount: (c: number) => any;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    /** 
     * filter awal untuk data
     */
    initialFilter: HotelBedData.SearchFilter;

    newRequestAvailability: (dari: string) => any;
    /**
     * real time database ref
     */
    realtimeDb: firebase.database.Database;

    firestoreDb: firebase.firestore.Firestore;

    updateInternalFilter: (filter: HotelBedData.SearchFilter) => any;
    /**
     * firebase uuid
     */
    uuid: string;
    // responKey: string;
    firebaseApp: firebase.app.App;
    pageChange: (page: number, dari: string) => any;
    page: number;
}
export interface WishlistPanelState extends BaseComponentState {
    panelState: 'NEW_REQ_AVAILABLE' | 'REQ_AVAILABLE_READY';
    // page: number;
    hotelCodes: number[];
    responKey: string;
    // requesting: boolean;
    currentFilter: HotelBedData.SearchFilter | any;
    wsCurrentFilter: HotelBedData.SearchFilter | any;
    // hotels: HotelBedData.PagedHotelbedData | any;
    externalFilter: any;
    error?: boolean;
    errorMessage?: string | any;
    // countHotels?: number;
    // filterRateChange: boolean;
    // indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    /*filterRate: {
        maxRate: number,
        minRate: number
    };*/
    version: number;
    wishlistCount: number;
    // leftPanelRequesting: string;
}

export class WishlistPanel extends BaseComponent<WishlistPanelProps, WishlistPanelState> {

    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['lang', 'currency'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ['hotels', 'page', 'error', 'errorMessage', 'requesting', 'panelState'];

    recieveHotelDetailDataControlManager: RecieveHotelDetailDataControlManager = new RecieveHotelDetailDataControlManager();

    /**
     * panel sisi kiri
     */
    leftSidePanel: HotelsLeftSide;
    /**
     * Panel untuk list hotels
     */
    hotelMainPanel: HotelSearchResultWithUrlReqKeyMainPanel;

    constructor(props: WishlistPanelProps) {
        super(props);
        this.state = {

            panelState: 'NEW_REQ_AVAILABLE',
            // page: 0,
            hotelCodes: [],
            responKey: '',
            // requesting: true,
            currentFilter: null,
            // hotels: null,
            externalFilter: {},
            wishlistCount: 0,
            // countHotels: 5,
            // filterRateChange: false,
            /*filterRate: {
                maxRate: 100000000,
                minRate: 0
            },
            indexedCategoryData: getOnlyFromCacheHotelCategoryCatalog(),
            */
            version: 0,
            // leftPanelRequesting: 'request',
            wsCurrentFilter: null
        };
    }

    shouldComponentUpdate(nextProps: WishlistPanelProps, nextState: WishlistPanelState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(WishlistPanel.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(WishlistPanel.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.getData(); 
    }
    
    componentDidUpdate(prevProps: WishlistPanelProps, prevState: WishlistPanelState) {
        if (prevProps.id !== this.props.id) {
            this.getData();
        }
    }

    getData = () => {
        getAjaxhelper().post(`/dynamics/hb-api/get-wishlist`, { id: this.props.id }).then(
            (data) => {
                let filter: any = data.filter;
                let hotelCodes: number[] = data.hotelCodes;
                this.setStateHelper(
                    st => {
                        st.wishlistCount = data.hotelCodes.length;
                        st.currentFilter = filter;
                        st.wsCurrentFilter = filter;
                        st.hotelCodes = hotelCodes;
                    },
                    () => {
                        let x = this.state.currentFilter;
                        sendHotelAvailibilityRequest({ filter: x, app: this.props.firebaseApp }).then(d2 => {
                            this.setStateHelper(st2 => {
                                st2.responKey = d2.responKey;
                                st2.panelState = 'REQ_AVAILABLE_READY';
                                window["responKey"] = d2.responKey;
                            });
                        });
                    });

            }).catch(exc => {
                console.log(exc);

            });
    }

    render() {
        const props = this.props;
        const state = this.state;
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let dateWh;
        if ((state.currentFilter)) {
            let filter = state.currentFilter;
            let stdt = (filter.stay.checkIn);
            let endt = (filter.stay.checkOut);
            dateWh = <span style={{ fontSize: 18, color: '#fff', float: 'left' }}> Wishlist For  Check In Date : {stdt} Check Out Date {endt} </span>;
        }
        let pesanAtas = (
            <div className="" style={{ margin: '0', marginBottom: 20 }}>
                <div style={{ padding: '15px 15px', background: '#007AFF', textAlign: 'right', borderRadius: 5 }}>
                    {dateWh}
                    <button
                        type='button'
                        className='btn btn-warning float-right'
                        onClick={() => {
                            /*
                            let wishlistRequest = {
                                status: 'CLOSE',
                                code: this.props.id
                            };
                            */
                            localStorage.removeItem(LOCAL_STORAGE_KEY_WISHLIST);
                            sessionStorage.removeItem(SESSION_STORAGE_HOTEL_FILTER_CURRENT_REQ_KEY);
                            // sessionStorage.removeItem(BHAM_STORAGE_WISHLIST);
                            this.props.wishlistCount(1);
                            this.props.history.push('/');
                            /*
                            getAjaxhelper().post("/dynamics/hb-api/cms-wishlist", wishlistRequest).then(d => {
                                
                            }).catch(exc => {
                                console.log(exc);
                             });
                             */
                        }}
                    > Clear My Wishlist
                    </button>
                </div>
            </div>
        );
        if (this.state.panelState === 'REQ_AVAILABLE_READY') {
            return (
                <div>
                    <HotelSearchResultWithUrlReqKeyMainPanel
                        ref={d => {this.hotelMainPanel = d as any; window["hotelMainPanel"] = d; console.log("Simpan hotelMainPanel", this.hotelMainPanel); }}
                        responKey={this.state.responKey}
                        currency={props.currency}
                        history={props.history}
                        lang={this.props.lang}
                        initialFilter={state.currentFilter}
                        getHotels={this.props.getHotels}
                        pageSize={15}
                        newRequestAvailability={props.newRequestAvailability}
                        realtimeDb={props.realtimeDb}
                        firestoreDb={props.firestoreDb}
                        updateInternalFilter={props.updateInternalFilter}
                        wishlistCount={this.wishlistCount}
                        uuid={props.uuid}
                        pesanAtas={pesanAtas}
                        firebaseApp={this.props.firebaseApp}
                        pageChange={this.props.pageChange} 
                        page={this.props.page}
                    />
                </div>
            );
        }
        return <span>TDADADA</span>;
    }
    wishlistCount: (n: any) => any = n => {
        //
    }

}


// WEBPACK FOOTER //
// ./src/cms/WishlistPanel.tsx